import { Vue, Component, Watch } from "vue-property-decorator";
import { AiSide } from "./AiSide/index";
import { AiMain } from "./AiMain/index";
import {
    getUserCatalog,
    getNextItem,
    getExamQuestions,
    examSubmit
} from "@/api/aijiaoaiCourse";
import { getLiveInfo } from "@/api/course";

import vueScroll from "vuescroll";
import { isNotEmpty } from "@/libs/tools";
import { decrypt } from "@/libs/AESTool";
import { ChoiceResult } from "./components/ChoiceResult/index";
import { isEmpty } from "@/libs/tools";
import { CodeHelp } from "./components/CodeHelp/index";
import { FeedBack } from "./components/FeedBack/index";
import { AiCongrats } from "./components/AiCongrats/index";
import { CourseExpire } from "@/components/CourseExpire/index";
import { ExpReport } from "@/components/ExpReport/index";
import { UserRate } from "./components/UserRate/index";
import { AiGuide } from "@/pages/aijiaoai/Guide";
import { MustdoTips } from "./components/MustdoTips/index";
import { IFNextDataParam } from "./type";

@Component({
    components: {
        AiSide,
        AiMain,
        vueScroll,
        ChoiceResult,
        CodeHelp,
        FeedBack,
        AiCongrats,
        MustdoTips,
        CourseExpire,
        UserRate,
        ExpReport,
        AiGuide
    }
})
export default class Elementary extends Vue {
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(255, 255, 255, .4)"
        }
    };

    private courseId: number = 1; //当前课程ID  点击去学习传递过来的值
    private courseList: Array<any> = []; //课程列表 传递给AiMain组件
    private catalogs: Array<any> = []; //当前课程所有的内容
    private sections: Array<any> = []; // 当前课程所有的小节
    private allData: Array<any> = []; //存储右侧的对话数据
    private chapters: Array<any> = []; // 当前课程所有的章

    private userAnswer: any = null;
    private currentSection: any = { name: "", id: 0, userNext: false };
    private currentPage: any = { allStep: 1, currentStep: 0 };
    private percentValue: number = 0;
    private examDetail: any = {
        // 当主体滚动时，测试小节顶部题目编号固定在顶部
        examStickyTop: false,
        isAnsweringQuestion: true,
        examPass: false,
        tempTime: null,
        showScore: false,
        isChoiceAgain: false
    };
    private isFinshed: boolean = false;
    private pollNextDisable: boolean = false;
    private exam: any = {};
    private needHlep: boolean = false;
    private showCongrats: any = {
        showCongrats: false,
        count: 3
    };
    private showCourseRate: any = {
        isShowRate: false
    };
    private showChoice: boolean = false;
    private timer: any;
    private userNext: boolean = false;
    private update: boolean = null;
    private expiredInfo: any = {
        isExpired: false,
        isFormal: false,
        isWaitingOpen: false,
        productId: null,
        msg: null,
        showCloseIcon: false,
        closeTips: false,
        isLock: false
    };
    private tipsInfo: any = {
        isChoice: false
    };
    private productId: number = null;
    private storageSection: any = {};
    private isChoiceAgain = false;
    private isGuide: boolean = false; // 右侧展示是否是导读
    private guideContents: any = {}; // 导读内容
    private showExpReport: boolean = false; // 是否显示试学报告
    private codeResult: string = "";
    private isRight: string = null;
    //正常类型参数
    private normalNextData: IFNextDataParam = {
        courseId: this.courseId,
        sectionId: this.currentSection.id,
        id: this.currentPage.id,
        logicId: this.currentPage.logicId,
        userAnswer: this.userAnswer,
        answer: null
    };
    // 编程类型参数
    private codeNextData: IFNextDataParam = {
        courseId: this.courseId,
        sectionId: this.currentSection.id,
        id: this.currentPage.id,
        logicId: this.currentPage.logicId,
        userAnswer: this.userAnswer,
        answerResult: this.codeResult,
        isRight: this.isRight,
        update: false
    };
    private isJumpClick: boolean = false;

    @Watch("productId") getProductId(val) {
        this.expiredInfo.productId = val;
    }
    get isShowFeedBack() {
        return this.$store.state.aistudy.isShowFeedBack;
    }
    @Watch("isShowFeedBack") getShowFeedBack(val) {}
    mounted() {
        /**
         * 首次家在进入页面判断是否有大纲页面传递过来的小节存储 有则进入该小节
         * 无则判断是否有学习主体页面的缓存 有则进入 无则跳转到最新学习的小节
         */
        this.courseId = parseInt(this.$route.params.courseId);

        //  大纲页面点击小节的存储
        let outlineSection = JSON.parse(
            localStorage.getItem("sectionItem" + this.courseId)
        );

        if (outlineSection && Object.keys(outlineSection).length !== 0) {
            this.storageSection = { ...outlineSection };
            // 如果当前小节是完成状态 则把继续学习改为下一节
            if (this.storageSection.status === "FINISHED") {
                this.userNext = true;
            }
        }
        this.$nextTick(() => {
            // 储存courseId 防止点击浏览器回退loding页面获取不到id
            localStorage.setItem("courseId", this.courseId + "");
            // 获取用户大纲 调接口
            this.fetchUserCatalog(this.courseId, this.storageSection);
            this.percentValue =
                (this.currentPage.currentStep / this.currentPage.allStep) * 100;

            const toPath = localStorage.getItem("toPath");
            if (toPath) {
                localStorage.removeItem("toPath");
            }
            document.addEventListener("keydown", e => {
                if (e.key === "Enter") {
                    if (
                        //@ts-ignore 兼容 FireFox
                        e.target.localName === "textarea" ||
                        //@ts-ignore  // 阻止代码编辑器按回车键冒泡，在编辑器中按回车enter的path是38
                        (e.path && e.path.length > 10)
                    ) {
                        e.stopPropagation();
                        e.preventDefault();
                    } else if (this.isShowFeedBack) {
                        // 反馈弹窗出现 停止调用next
                        return;
                    } else if (this.currentPage.isCoding) {
                        this.showChoice = true;
                        this.tipsInfo.isChoice = false;
                    } else if (
                        this.currentPage.currentStep ===
                            this.currentPage.allStep &&
                        !this.pollNextDisable &&
                        this.currentSection.sectionType !== "EXAM" &&
                        this.currentPage.pageType !== "CHOICE" &&
                        !this.userNext &&
                        !this.currentPage.isCoding
                    ) {
                        this.handleNextSection(this.storageSection);
                    } else {
                        this.currentPage.currentStep !==
                        this.currentPage.allStep
                            ? this.fetchNextContent()
                            : this.nextSectionClick(this.currentSection.id);
                    }
                }
            });
        });
    }

    /**
     * 获取左侧用户大纲方法 + 获取对话流的内容方法 初始化页面
     * @param courseId
     * @param storageSection 本地储存的小节对象
     */
    fetchUserCatalog(courseId, storageSection) {
        // 是否需要校验物权 1需要 0不需要
        let checkDue = this.expiredInfo.isExpired ? 1 : 0;
        getUserCatalog(courseId, checkDue, true).then(res => {
            //@ts-ignore
            if (res.code === 200) {
                this.courseList = res.data;
                this.productId = res.data.productId;
                this.catalogs = res.data.children;
                // 控制章节的展开状态
                this.catalogs.forEach(moduleItem => {
                    moduleItem.children.forEach(chapterItem => {
                        if (chapterItem.status === "LEARNING") {
                            this.$set(chapterItem, "collapse", true);
                        } else {
                            this.$set(chapterItem, "collapse", false);
                        }
                        //筛选出所有的chapter
                        this.chapters.push(chapterItem);
                        chapterItem.children.forEach(groupItem => {
                            groupItem.children.forEach(sectionItem => {
                                this.$set(sectionItem, "currentClicked", false);
                                //筛选出所有的section
                                this.sections.push(sectionItem);
                            });
                        });
                    });
                });

                // 找到当前正在学习的小节
                if (Object.keys(storageSection).length !== 0) {
                    this.currentSection = storageSection;
                } else {
                    // TODO 这里查找正在学习的小节是否能放到catalogs循环中去判断？
                    this.currentSection =
                        this.findLearningSection(this.sections) ||
                        this.findLastSection(this.sections);
                }
                // 展开大纲页面section对应的章节
                this.chapterClick(this.currentSection, this.sections);
                // 获取中间对话流内容
                this.fetchNextContent();
                //@ts-ignore
            } else if (res.code === 2025) {
                // 课程过期
                this.expiredInfo.isExpired = true;
                this.expiredInfo.productId = this.productId;
                //@ts-ignore
            } else if (res.code === 2026) {
                // 课程未开课
                this.expiredInfo.isWaitingOpen = true;
                //@ts-ignore
                this.expiredInfo.msg = res.msg;
                this.expiredInfo.showCloseIcon = true;
            }
        });
    }

    // 查找状态为1的小节 正在学习的小节
    findLearningSection(sections) {
        for (let i = 0; i < sections.length; i++) {
            if (sections[i].status && sections[i].status === "LEARNING") {
                return sections[i];
            }
        }
    }
    //查找下一个小节
    findNextSection(section, sections) {
        // 当section是从大纲页面传递过来的时候 值相等但是引用地址不同 使用indexOf index会返回-1
        let index;
        for (let i = 0; i < sections.length; i++) {
            if (section.id == sections[i].id) {
                index = i;
            }
        }
        if (index < 0) {
            index = -1;
        }

        let nextSection =
            index === sections.length - 1
                ? sections[index]
                : sections[index + 1];
        // 如果下一小节还未开始学
        if (nextSection.status === "UNLEARNED") {
            // 把当前的小节状态改为finish
            section.status = "FINISHED";
            // 把下一小节状态改为learning
            nextSection.status = "LEARNING";
        }
        return nextSection;
    }
    // 查找最后一个小节
    findLastSection(sections) {
        return sections[sections.length - 1];
    }

    // 点击大纲小节 跳并记录位置
    handleSectionClick(section) {
        // this.courseId = parseInt(this.$route.params.courseId);
        if (section.status === "UNLEARNED") {
            this.$message.warning("请按顺序学习完成前面的课程！");
            return;
        }
        if (section.status === "FINISHED") {
            this.userNext = true;
        } else {
            this.userNext = false;
        }
        // 当前小节所在章节为展开状态
        this.chapterClick(section, this.sections);
        // 更新大纲页面缓存小节把当前点击的小节存在storage中 防止刷新页面后自动跳转到最新小节
        localStorage.setItem(
            "sectionItem" + this.courseId,
            JSON.stringify(section)
        );
        this.currentSection = section;
        this.currentPage = {};
        this.allData = [];
        this.fetchNextContent();
    }

    // 设置当前小节所在章节为展开状态
    chapterClick(curSection, nowSections) {
        let nameIdex;
        this.chapters.forEach(chapterItem => {
            chapterItem.children.forEach(groupItem => {
                groupItem.children.forEach(sectionItem => {
                    if (sectionItem.sectionName === curSection.sectionName) {
                        nameIdex = chapterItem.chapterIndex;
                        this.$set(chapterItem, "collapse", true);
                        this.$set(chapterItem, "status", "LEARNING");
                    } else {
                        this.$set(chapterItem, "collapse", false);
                    }
                });
            });
        });
        let name = curSection.sectionName;
        let matchName = name.match(/(\S*)\./);

        if (matchName && matchName[1]) {
            nameIdex = matchName[1];
        }

        // 该判断是否有导读 有下标则nameIdex 无则 nameIdex - 1
        if (nowSections[0] && nowSections[0].sectionType === "INTRODUCTION") {
            if (nameIdex && this.chapters[nameIdex]) {
                this.$set(this.chapters[nameIdex], "collapse", true);
            }
        } else {
            if (nameIdex && this.chapters[nameIdex - 1]) {
                this.$set(this.chapters[nameIdex - 1], "collapse", true);
            }
        }

        // 学过的小节 点击状态颜色高亮
        for (let i = 0; i < nowSections.length; i++) {
            // nowSections[i].status === "FINISHED" &&
            if (nowSections[i].id === curSection.id) {
                this.$set(nowSections[i], "currentClicked", true);
            } else {
                this.$set(nowSections[i], "currentClicked", false);
            }
        }
    }

    // 继续学习
    fetchNextContent(choiceSelect?: any) {
        if (choiceSelect && choiceSelect.key) {
            this.userAnswer = choiceSelect.key;
            this.normalNextData.answer = this.currentPage.page.answer;
        }
        // 测试小节
        if (this.currentSection.sectionType === "EXAM") {
            this.fetchExam(this.examDetail.isChoiceAgain);
            return;
        }
        // 导读小节
        if (this.currentSection.sectionType === "INTRODUCTION") {
            this.fetchGuideContent();
            this.isGuide = true;
            getNextItem({
                courseId: this.courseId,
                sectionId: this.currentSection.id,
                id: this.currentPage.id,
                logicId: this.currentPage.logicId,
                userAnswer: this.userAnswer
            });
            return;
        }
        this.isGuide = false;
        this.codeNextData.courseId = this.normalNextData.courseId = this.courseId;
        this.codeNextData.sectionId = this.normalNextData.sectionId = this.currentSection.id;
        this.codeNextData.id = this.normalNextData.id = this.currentPage.id;
        this.codeNextData.logicId = this.normalNextData.logicId = this.currentPage.logicId;
        this.codeNextData.userAnswer = this.normalNextData.userAnswer = this.userAnswer;

        let param;
        this.isJumpClick
            ? (param = this.codeNextData)
            : (param = this.normalNextData);
        return new Promise((resolve, reject) => {
            getNextItem(param).then(res => {
                //@ts-ignore
                if (res.code === 200) {
                    // let nextItem = decrypt(res.data);
                    let nextItem = res.data;
                    // console.log(nextItem);
                    this.userAnswer = null;
                    //有返回值
                    if (nextItem.length !== 0) {
                        this.currentPage = nextItem[nextItem.length - 1];
                        this.percentValue =
                            (this.currentPage.currentStep /
                                this.currentPage.allStep) *
                            100;
                        // 解决线上环境google浏览器点击next之后不滚动
                        this.currentSection.sectionType !== "EXAM"
                            ? setTimeout(
                                  () =>
                                      (this.$refs["vs"] as any).scrollTo(
                                          { y: "100%" },
                                          0
                                      ),
                                  100
                              )
                            : "";
                    }
                    // 章节学完无返回值
                    if (
                        this.currentPage.currentStep ===
                            this.currentPage.allStep &&
                        nextItem.length === 0
                    ) {
                        // 下一节
                        this.handleSectionClick(
                            this.findNextSection(
                                this.currentSection,
                                this.sections
                            )
                        );
                    }
                    let lastType;
                    let lastNum;
                    nextItem.forEach(sectionItem => {
                        let secType = sectionItem.pageType;
                        lastNum = nextItem.length - 1;
                        lastType = nextItem[lastNum].pageType;
                        //是编程类型且不是最后一条
                        if (
                            secType === "COMPARE" ||
                            secType === "COPY" ||
                            secType === "HINT" ||
                            secType === "ONLY"
                        ) {
                            this.$set(sectionItem, "isShowJump", false);
                        }
                    });
                    let curType = this.currentPage.pageType;
                    if (
                        curType === "COPY" ||
                        curType === "COMPARE" ||
                        curType === "HINT" ||
                        curType === "ONLY"
                    ) {
                        this.$set(this.currentPage, "isShowJump", true);
                        this.$set(this.currentPage, "isCoding", true);
                        // 当前学习为编程题并且已经运行成功 将点改为继续学习按钮
                        if (
                            this.currentPage.isRight &&
                            this.currentPage.isRight === "YES"
                        ) {
                            this.$set(this.currentPage, "isCoding", false);
                        }
                    }
                    // 编程题是最后一题的情况 已完成再回来运行 不显示已跳过及按钮loading状态
                    if (
                        lastType === "COMPARE" ||
                        lastType === "COPY" ||
                        lastType === "HINT" ||
                        lastType === "ONLY"
                    ) {
                        if (nextItem[lastNum].status === "FINISHED") {
                            this.$set(this.currentPage, "isShowJump", false);
                            this.$set(this.currentPage, "isCoding", false);
                        } else {
                            this.$set(this.currentPage, "goLearing", false);
                        }
                    }

                    this.allData = this.allData.concat(nextItem);
                    resolve();
                }
                //@ts-ignore 小节锁定 需要购买
                else if (res.code === 2012) {
                    let reportStatus = localStorage.getItem("showExpReport");
                    if (reportStatus === "show") {
                        this.showExpReport = false;
                        this.expiredInfo.isLock = true;
                        if (this.expiredInfo.isLock) {
                            this.expiredInfo.showCloseIcon = true;
                        }
                        this.expiredInfo.productId = this.productId;
                    } else {
                        this.showExpReport = true;
                        localStorage.setItem("showExpReport", "show");
                    }
                }
                //@ts-ignore
                else if (res.code === 2027) {
                    // 选择题未选择
                    this.showChoice = true;
                    this.tipsInfo.isChoice = true;
                }
                //@ts-ignore
                else if (res.code === 2008) {
                    // 买了正式课程 但是部分课程未开课
                    this.expiredInfo.isWaitingOpen = true;
                    //@ts-ignore
                    this.expiredInfo.msg = res.msg;
                    this.expiredInfo.showCloseIcon = true;
                }
                //@ts-ignore
                else if (res.code === 1000) {
                    // this.$message.warning("同学你点击的太快了，慢点儿学习哟！");
                    return false;
                } else {
                    reject("next error");
                }
            });
        });
    }

    // 点击【导读】
    handleGuideClick({ chapterItem, section }) {
        this.currentSection = section;
        this.isGuide = true;

        this.handleSectionClick(section);
        this.fetchGuideContent();
    }
    fetchGuideContent() {
        getLiveInfo(this.courseId + "", "AIJIAOAI", "info-introduction").then(
            res => {
                this.guideContents = JSON.parse(
                    res.data.currentPageConfig.pageConfig
                );
            }
        );
    }
    handleNotChoice() {
        if (this.currentPage.pageType === "CHOICE") {
            if (!this.userAnswer) {
                this.showChoice = true;
                this.tipsInfo.isChoice = true;
            }
        }
    }
    closeTips() {
        this.showChoice = false;
        this.tipsInfo.isChoice = false;
    }
    handleNotRunCode() {
        // this.$message.warning("请先完成题目才能继续！");
        this.showChoice = true;
        this.tipsInfo.isChoice = false;
    }

    handleHiddenAside() {
        this.$store.state.aistudy.isAsideHidden = true;
    }

    handleExitClick() {
        // 退出学习 移除小节储存
        localStorage.removeItem("sectionItem" + this.courseId);
        this.$router.push("/myRoom/course");
    }

    //
    handleScroll(a) {
        if (this.currentSection.sectionType === "EXAM") {
            this.examDetail.examStickyTop = a.scrollTop > 100 ? true : false;
        }
    }

    handleSelect(choiceSelect) {
        this.fetchNextContent(choiceSelect);
    }

    handleNextSection(sectionId) {
        this.showCongrats.showCongrats = true;
        this.userNext = true;
        this.$set(this.currentSection, "userNext", this.userNext);

        let sectionId1 = this.currentSection.id;
        this.showCongrats.count = 3;
        this.timer = setInterval(() => {
            this.showCongrats.count--;
            if (this.showCongrats.count === 0) {
                clearInterval(this.timer);
                this.showCongrats.showCongrats = false;
                this.nextSectionClick(sectionId1);
            }
        }, 1000);
    }

    // 导读--> 开启学习之旅点击
    guideNextClick(sectionId) {
        this.isGuide = false;
        this.currentSection.status = "FINISHED";
        this.handleSectionClick(
            this.findNextSection(this.currentSection, this.sections)
        );
    }
    nextSectionClick(sectionId) {
        this.userNext = false;
        if (sectionId === this.currentSection.id) {
            if (this.currentSection.sectionType === "EXAM") {
                this.currentSection.status = "FINISHED";
                this.handleSectionClick(
                    this.findNextSection(this.currentSection, this.sections)
                );
            } else {
                if (this.currentPage.status === "FINISHED") {
                    this.handleSectionClick(
                        this.findNextSection(this.currentSection, this.sections)
                    );
                } else {
                    // 刷新章节学习进度
                    this.fetchNextContent();
                }
            }
        }
    }
    fetchExam(isAgain) {
        getExamQuestions(
            this.courseId,
            this.currentSection.id,
            1,
            isAgain
        ).then(res => {
            this.exam = res.data;
            // 未过关状态
            if (res.data.status === "LEARNING") {
                // 提交过答案 但是并未过关
                if (res.data.userScore > 0 && res.data.userScore < 60) {
                    this.examDetail.isAnsweringQuestion = false;
                } else {
                    this.examDetail.isAnsweringQuestion = true;
                    this.exam.questions.forEach(item => {
                        this.$set(item, "userAnswer", null);
                        this.$set(item, "startTime", null);
                        this.$set(item, "endTime", null);
                    });
                }
                this.examDetail.tempTime = new Date();
            } else {
                // 过关状态
                this.examDetail.isAnsweringQuestion = false;
                this.examDetail.examPass =
                    this.exam.userScore >= this.exam.passScore;
            }
        });
    }

    handleExamSubmit() {
        let examCheck = this.exam.questions.some(item =>
            isEmpty(item.userAnswer)
        );
        if (examCheck) {
            this.isFinshed = false;
            this.$message.warning("请完成所有测试题^_^");
        } else {
            this.isFinshed = true;
            examSubmit(this.exam).then(res => {
                //@ts-ignore
                if (res.code === 200) {
                    this.exam = res.data;
                    // this.examDetail.isAnsweringQuestion = false;
                    this.examDetail.showScore = true;
                    this.examDetail.examPass =
                        this.exam.userScore >= this.exam.passScore;
                    setTimeout(
                        () => (this.$refs["vs"] as any).scrollTo({ y: "0" }, 0),
                        100
                    );
                }
            });
        }
    }

    handleExamRefresh() {
        // 是否重新测试
        this.$set(this.examDetail, "isChoiceAgain", true);
        this.fetchExam(true);
        this.examDetail.isAnsweringQuestion = true;
        this.examDetail.showScore = false;
    }
    // 编程题目 跳过逻辑
    handleJumpClick(val) {
        this.$set(val, "isShowJump", false);
        this.$set(val, "isCoding", false);
        this.codeNextData.answerResult = val.codeResult;
        // 运行出错才有跳过本题 isRight 设置为NO
        this.codeNextData.isRight = "NO";
        this.isJumpClick = true;
        if (!val.goLearing) {
            this.fetchNextContent();
        }
    }

    exitExpReport(val) {
        if (val === "close") {
            // TODO 和next()里code 2012 优化一个方法
            this.showExpReport = false;
            this.expiredInfo.isLock = true;
            if (this.expiredInfo.isLock) {
                this.expiredInfo.showCloseIcon = true;
            }
            this.expiredInfo.productId = this.productId;
        }
    }
}

//@ts-ignore
export { default as Elementary } from "./index.vue";
